
import Authenticator from '../../components/Authenticator/Authenticator';
import { Pages } from '../../components/Pages/Pages';
import DraftCompletePage from '../../pages/DraftCompletePage/DraftCompletePage';
import HowToGetOfferPage from '../../pages/HowToApplyPage/HowToGetOfferPage';
import CoApplicantRequestNorskGjeldConsentPage from '../../pages/RequestNorskGjeldConsentPage/CoApplicantRequestNorskGjeldConsentPage';
import CoApplicantDraftRequestSBLConsentPage from '../../pages/RequestSBLConsentPage/CoApplicantDraftRequestSBLConsentPage';

const CoApplicantDraftWizard = () => {
    return (
        <Pages>
            <HowToGetOfferPage />
            <CoApplicantDraftRequestSBLConsentPage />
            <Authenticator autoLogin={true}>
                <CoApplicantRequestNorskGjeldConsentPage />
            </Authenticator>
            <DraftCompletePage />
        </Pages>
    );
};

export default CoApplicantDraftWizard;
